import React from 'react';
import IntlContext from './IntlContext';

const Date = ({ value }) => {
  return (
    <IntlContext.Consumer>{({ date }) => date(value)}</IntlContext.Consumer>
  );
};

export default Date;
